import { render, staticRenderFns } from "./DealerHighlight.vue?vue&type=template&id=466b21e2&scoped=true"
import script from "./DealerHighlight.vue?vue&type=script&lang=js"
export * from "./DealerHighlight.vue?vue&type=script&lang=js"
import style0 from "./DealerHighlight.vue?vue&type=style&index=0&id=466b21e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b21e2",
  null
  
)

export default component.exports